import { SbImage } from '@/components/Shared/Image/SbImage';
import { isStringWithValue } from '@/utils/helpers/isStringWithValue';
import { ITestimonialPage, IStoryBase } from '@/utils/interfaces/stories';

interface IProps {
	blok: IStoryBase<ITestimonialPage>;
	isLarge?: boolean;
}

export const TextTestimonial: React.FC<IProps> = ({ blok, isLarge = false }) => {
	const testimonialWrap = ['w-full flex'];
	const testimonialContent = ['flex  bg-white grow'];
	const testimonialImage = ['relative w-full'];
	const testimonialImageWrap = ['relative shrink-0 grow-0'];
	if (isLarge) {
		testimonialWrap.push('flex-col md:flex-row');
		testimonialContent.push('text-green-dark');
		testimonialImage.push('h-60');
		testimonialImageWrap.push('md:w-60 flex items-center justify-center');
	} else {
		testimonialContent.push('sm:pl-4 md:pl-8 text-green-dark/80');
		testimonialImage.push('h-24 md:h-32');
		testimonialImageWrap.push('w-24 md:w-32');
	}
	return (
		<div className={testimonialWrap.join(' ')}>
			<div className={testimonialContent.join(' ')}>
				<div style={{ borderTopColor: 'rgba(31, 41, 55, 0.2)' }} className="w-full flex justify-between flex-col pt-[34px] sm:px-[78px] border-t-[1px] border-gray-dark">
					<p className='text-base xl:text-[20px]'>
						{blok.content.content}
					</p>
					<div className="items-center justify-between mt-6 md:flex">
						<div className="flex flex-wrap text-sm md:text-base">
							<span className="font-bold text-green">
								{blok.content.author}
							</span>
							{isStringWithValue(blok.content.company) && (
								<>
									<span className="h-6 mx-3 border-l border-gray" />
									<span className="text-green-dark">
										{blok.content.company}
									</span>
								</>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
